import React from "react";
import { useTranslation } from "react-i18next";

function FinancialSection() {
    const { t } = useTranslation();
    const total = 74170;
    const items = [
        { title: t("finMealsTitle"), desc: t("finMealsDesc"), amount: 25500 },
        { title: t("finEduTitle"), desc: t("finEduDesc"), amount: 8870 },
        { title: t("finRentTitle"), desc: t("finRentDesc"), amount: 11800 },
        { title: t("finOpsTitle"), desc: t("finOpsDesc"), amount: 28000 },
    ].map(item => ({ ...item, pct: Math.round((item.amount / total) * 100) }));
    const [barWidths, setBarWidths] = React.useState(() => items.map(() => 0));

    React.useEffect(() => {
        const t = setTimeout(() => {
            setBarWidths(items.map(item => item.pct));
        }, 100);
        return () => clearTimeout(t);
    }, []);
    return (
        <section className="landing-section landing-section-soft">
            <div className="container">
                <div className="landing-fin-head">
                    <div>
                        <div className="landing-eyebrow">{t("financialEyebrow")}</div>
                        <h2 className="landing-heading">{t("financialTitle")}</h2>
                    </div>
                    {/* <p className="landing-section-desc">{t("financialSubtitle")}</p> */}
                </div>
                <div className="landing-fin-grid">
                    <div className="landing-fin-list">
                        {items.map((item, index) => (
                            <div key={item.title}>
                                <div className="landing-fin-top">
                                    <div>
                                        <span className="landing-fin-name">{item.title}</span>
                                        <div className="landing-fin-desc">{item.desc}</div>
                                    </div>
                                    <span className="landing-fin-amount">RM {item.amount.toLocaleString()}</span>
                                    <span className="landing-fin-pct">{item.pct}%</span>
                                </div>
                                <div className="landing-fin-bar">
                                    <div className="landing-fin-bar-fill" style={{ width: barWidths[index] + "%" }}></div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div>
                        <div className="landing-fin-summary">{t("finSummary")}</div>
                        <p className="landing-fin-note">{t("finNote")}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default FinancialSection;